<!--
 * Path: src/core/components/common/FormSection.vue
 * Task: A structural wrapper for logical groups of form fields.
 * Update: Added left padding (ps-2) to the title to align it perfectly with the nested form elements.
-->
<template>
  <div class="form-section-wrapper mb-6">
    <div class="text-caption font-weight-bold text-medium-emphasis text-uppercase mb-4 ps-2" style="letter-spacing: 1.5px;">
      {{ title }}
    </div>

    <div class="form-section-content">
      <slot></slot>
    </div>

    <v-divider class="mt-8 mb-4"></v-divider>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
}>();
</script>

<style scoped>
.form-section-wrapper {
  position: relative;
}
.form-section-content {
  position: relative;
}
</style>
